export default __webpack_public_path__ + "static/media/excel.3410d7ad.svg";